import * as React from "react";

const IconPaginationLargeLeft: React.FC = () => (
    <svg
        width="11px"
        height="20px"
        viewBox="0 0 11 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <polygon
            fill="currentColor"
            points="0 10 .606 9.381 9.183 .619 9.788 0 11 1.238 10.394 1.857 2.423 10 10.394 18.143 11 18.762 9.788 20 9.183 19.381 .606 10.619"
        />
    </svg>
);

export default React.memo(IconPaginationLargeLeft);
